export default "__VITE_ASSET__71d4d98a__"